import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { WarehouseTransactionGroup } from 'src/app/core/models/warehouse-transaction-group';
import { WarehouseTransactionGroupService } from 'src/app/core/services/general/warehouse-transaction-group.service';

@Component({
  selector: 'app-warehouse-transaction-group-input',
  templateUrl: './warehouse-transaction-group-input.component.html',
  styleUrls: ['./warehouse-transaction-group-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: WarehouseTransactionGroupInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: WarehouseTransactionGroupInputComponent,
    },
  ],
})
export class WarehouseTransactionGroupInputComponent {
  @Input()
  title = "Select Group...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public warehouseTransactionGroupsList: Array<CustomSelectOption> = [];

  constructor(
    private warehouseTransactionGroupService: WarehouseTransactionGroupService,
  ) {
    this.warehouseTransactionGroupService
      .all()
      .subscribe((res: Array<WarehouseTransactionGroup>) => {
        this.warehouseTransactionGroupsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.warehouseTransactionGroupsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
